import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import Page from 'pages/Page';

import { apiAdminMe } from '@/components/admin/api';
import Chat from '@/components/chat';
import { TODAY_API, fetchEngineStatus } from '@/components/engine/api';

// Once per browser session, a company that has any engine screen lands on
// Today instead of the chat: Belal, 2026-11-05. "/" stays the chat for every
// link, New chat and the ERP hand-off; only the first arrival is sent on.
const LANDED = 'signals.landedToday';

function landedThisSession(): boolean {
  try {
    return window.sessionStorage.getItem(LANDED) === '1';
  } catch {
    return true;
  }
}

function markLanded() {
  try {
    window.sessionStorage.setItem(LANDED, '1');
  } catch {
    /* private mode: the chat opens as before */
  }
}

// Admin accounts have no chat: no container seat, no message allowance and no
// tenant data. Rather than dropping them into a chat that refuses every
// message, send them straight to Configurations. The role comes from the
// server (/api/admin/me answers 403 for everyone else), never from the client.
export default function Home() {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  // null = not asked yet (first arrival only); false = stay on the chat.
  const [toToday, setToToday] = useState<boolean | null>(
    landedThisSession() ? false : null
  );

  useEffect(() => {
    let cancelled = false;
    apiAdminMe()
      .then(() => {
        if (!cancelled) setIsAdmin(true);
      })
      .catch(() => {
        if (!cancelled) setIsAdmin(false);
      });
    if (!landedThisSession()) {
      markLanded();
      fetchEngineStatus(TODAY_API)
        .then((s) => {
          if (!cancelled) setToToday(!!s.available);
        })
        .catch(() => {
          if (!cancelled) setToToday(false);
        });
    }
    return () => {
      cancelled = true;
    };
  }, []);

  if (isAdmin === null || toToday === null) return null; // one paint, avoids a chat flash
  if (isAdmin) return <Navigate replace to="/admin" />;
  if (toToday) return <Navigate replace to="/today" />;

  return (
    <Page>
      <Chat />
    </Page>
  );
}
